// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_eoQ","colMin":"styles_colMin__tZH2o"};